// removed by extract-text-webpack-plugin
module.exports = {"main":"segment-name-display-main--18PsV","segmentIcon":"segment-name-display-segmentIcon--KjTdG","segmentName":"segment-name-display-segmentName--3d0rb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SegmentNameDisplay/segment-name-display.scss
// module id = sEPu
// module chunks = 4